import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FurnitureComponent } from './furniture/furniture.component';
import { FurnitureService } from './api/furniture.service';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from '../app-routing.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [FurnitureComponent],
  imports: [CommonModule, SharedModule, AppRoutingModule, HttpClientModule],
  providers: [FurnitureService],
})
export class FurnitureModule {}
